var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('share-base',{staticClass:"c-share-link--twitter",attrs:{"href":("http://twitter.com/share?url=" + _vm.urlOnShare + "&text=" + _vm.text + "&hashtags=" + _vm.hashtags)},on:{"click":function($event){return _vm.$emit('share-click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }